"use client";

import { trackPageView } from "analytics";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useCookieSettings } from "hooks/cookies/useCookieSettings";

export function TrackPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    cookieSettings: { allowAnalytics, hasDismissed }
  } = useCookieSettings();

  useEffect(() => {
    // Only dismissed cookie modal and allowAnalytics is true
    if (hasDismissed && allowAnalytics) {
      trackPageView();
    }

    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, [hasDismissed, allowAnalytics, pathname, searchParams]);

  return null;
}
